<template>
    
    <div class="h-full w-full lg:max-w-2xl xl:max-w-lg mx-auto relative">
        
        <div v-if="showMenu" class="w-full top-0 z-50 bg-white fixed shadow-md">
            <filters></filters>
        </div>

        <totalSales></totalSales>
        <topSales></topSales>
        <orders></orders>

        <div class="h-2"></div>

    </div>

</template>

<script>
    import { state } from '@/store';
    import totalSales from '../../components/totalSales.vue';
    import topSales from '../../components/topSales.vue';
    import orders from '../../components/orders.vue';
    import filters from '../../components/filters.vue';

    export default {
        name: 'Retail',
        components:{
            totalSales,
            topSales,
            orders,
            filters
        },
        computed: {

            showMenu(){
                return state.showMenu
            }

        },

        watch:{
            showMenu(n,o){
                
            }
        }
    }
</script>
